export var splitString = function (string) { return string.split(/\r?\n/).filter(Boolean); };
export var unifyQueryParams = function (string) {
    if (string === void 0) { string = ''; }
    return string.charAt(0) === '?' ? string : "?".concat(string);
};
export var COOKIE_BRAZE = 'manual_braze';
export var defineCardContent = function (cardObject) {
    var description = splitString(cardObject.description);
    var url = unifyQueryParams(cardObject.url).replace(/\s/g, ''); // to ensure that manual spaces aren't inserted
    var voucherAndExpirations = url.replace('?z_coup=', '').split('&z_expire=');
    var brazeVoucher = voucherAndExpirations[0];
    var brazeVoucherExpire = voucherAndExpirations[1];
    return {
        title: cardObject.title,
        message: description[0],
        ctaText: cardObject.linkText || '',
        footNote: description[1],
        url: url,
        brazeVoucher: brazeVoucher,
        brazeVoucherExpire: brazeVoucherExpire,
    };
};
